import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-900 border-t border-navy-800 py-12 px-4 sm:px-6 lg:px-8 text-center" data-id="element-167">
      <div className="max-w-4xl mx-auto" data-id="element-168">
        <div className="mb-8" data-id="element-169">
          <h3 className="text-2xl font-bold text-gold-400 mb-2" data-id="element-170">
            🐾 MUNDORECURSOS™
          </h3>
          <p className="text-blue-100/80 max-w-md mx-auto" data-id="element-171">
            El sistema N°1 para dueños de perros en departamento.
          </p>
          <p className="text-white font-medium mt-4 italic" data-id="element-172">
            "Porque tener un perro en la ciudad no debería cobrarte la paz todos
            los días."
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-12 text-blue-200/70" data-id="element-173">
          <a href="mailto:soportemundorecursos@gmail.com" className="flex items-center gap-2 hover:text-gold-400 transition-colors" data-id="element-174">
            <Mail className="w-5 h-5" data-id="element-175" /> soportemundorecursos@gmail.com
          </a>
          <a href="https://www.instagram.com/mundorecursos.online/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-gold-400 transition-colors" data-id="element-176">
            <Instagram className="w-5 h-5" data-id="element-177" /> @mundorecursos.online
          </a>
          <a href="https://www.mundorecursos.store" className="flex items-center gap-2 hover:text-gold-400 transition-colors" data-id="element-178">
            <Globe className="w-5 h-5" data-id="element-179" /> www.mundorecursos.store
          </a>
        </div>

        <div className="border-t border-navy-800 pt-8 text-sm text-navy-500" data-id="element-180">
          <p className="mb-4" data-id="element-181">
            © MundoRecursos™ 2026 — Todos los derechos reservados. Prohibida
            la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}